export class DropdownModel {
  value: number;
  text:string;
}

export class DropdownModelWithStatus {
  value: number;
  text: string;
  isDisabled:boolean=false;
}

export class CheckboxModel {
  value: number;
  text: string;
  checked: boolean = false;
}

export class CheckboxModelWithStatus {
  value: number;
  text: string;
  checked: boolean;
  isDisabled: boolean = false;
}

export class DefaultProjectHoursListModel {
  id: number;
  defaultProjectHours: number;
}

export class ServiceDefaultModel {
  id: number;
  defaultProjectHours: number;
  servicesName: string;
  checked: boolean;
}


export class CheckboxServiceDefaultListModel {
  value: number;
  text: string;
  checked: boolean;
  defaultProjectHours: number;
}
